import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

interface IProps {
  hasAllowAllAccessPermission: boolean;
}

export const upsertPricingProfileAccessSchema = ({ hasAllowAllAccessPermission = false }: IProps) =>
  yup
    .object()
    .shape({
      allCustomers: yup.boolean().required(),
      allUsers: yup.boolean().required(),
      allLocations: yup.boolean().required(),
      allRegions: yup.boolean().required(),
      customers: yup.array().when('allCustomers', {
        is: false,
        then: yup.array().of(
          yup.object().shape({
            customerContactGroup: yup
              .object()
              .nullable()
              .required(getEmptyErrorMessage(t('labelCustomer'))),
            customerLocations: yup
              .array()
              .min(1, getEmptyErrorMessage(t('labelLocation')))
              .required(getEmptyErrorMessage(t('labelLocation'))),
          })
        ),
      }),
      users: yup.array().when('allUsers', {
        is: false,
        then: yup.array().of(
          yup.object().shape({
            user: yup
              .object()
              .nullable()
              .required(getEmptyErrorMessage(t('labelUser'))),
          })
        ),
      }),
      locations: yup.array().when('allLocations', {
        is: false,
        then: yup.array().of(
          yup.object().shape({
            location: yup
              .object()
              .nullable()
              .required(getEmptyErrorMessage(t('labelLocation'))),
          })
        ),
      }),
      regions: yup.array().when('allRegions', {
        is: false,
        then: yup.array().of(
          yup.object().shape({
            region: yup
              .object()
              .nullable()
              .required(getEmptyErrorMessage(t('labelRegion'))),
          })
        ),
      }),
    })
    .test('accessAllRestriction', t('errorPricingProfileAccessAllNotAllowed'), (value) => {
      if (!value || hasAllowAllAccessPermission) {
        return true;
      }

      const { allCustomers, allUsers, allLocations, allRegions } = value;
      const allFieldsSetToAllowAll = allCustomers && allUsers && allLocations && allRegions;

      // If user doesn't have permission to grant access to all, return error
      return !allFieldsSetToAllowAll;
    });
